import {
  PaginatedPassengerAddressListRead,
  PassengerAddressRead,
} from 'src/common/external/bambi-api/bambiApi';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

export default function getRecentAddressesAsOptions(
  recentAddressResponse: PaginatedPassengerAddressListRead | undefined
): SelectOption[] {
  return (
    recentAddressResponse?.results.map((result) => ({
      label: getLabelForAddress(result),
      value: result.address.location?.place_id || '',
    })) || []
  );
}

function getLabelForAddress(address: PassengerAddressRead): string {
  if (!address.address.location?.label) {
    return '';
  }

  const name = address.name;
  if (name) {
    return `(${name}) ${address.address.location.label}`;
  }
  return address.address.location.label;
}
